module.exports = __webpack_public_path__ + "static/media/bam-ireland.b325bb39.png";